import { each } from 'lodash/each'
import { app } from '../utils/store'

import gsap from 'gsap'

class Modal {
    toggle(entry) {
        entry.onclick = (event) => {
            event.stopPropagation()
            event.preventDefault()

            let data_modal = entry.getAttribute('data-modal-target'),
                modal = document.querySelector('[id="' + data_modal + '"]')

            if (modal.hasAttribute('data-modal-video') || modal.hasAttribute('data-modal-gallery')) {
                const videos = modal.querySelectorAll('video');
                if (videos.length > 0) {
                    videos.forEach(video => {
                        video.pause();
                    });
                    document.body.classList.remove('modal-video--open');
                }
            }


            modal.classList.add('active')

            app.html.classList.add('scroll--off')
            app.root.classList.add('modal--open')

            modal.isOpen = true
            modal.current = data_modal
        }
    }

    close(entry) {
        let modals = document.querySelectorAll('.modal')

        entry.onclick = (event) => {
            event.stopPropagation()
            event.preventDefault()

            var modal = entry.parentNode

            if (modal.hasAttribute('data-modal-video') || modal.hasAttribute('data-modal-gallery')) {
                const videos = modal.querySelectorAll('video');
                if (videos.length > 0) {
                    videos.forEach(video => {
                        video.pause();
                    });
                    document.body.classList.remove('modal-video--open')
                }
            }

            modals.forEach((entry) => { entry.classList.remove('active') })

            app.html.classList.remove('scroll--off')
            app.root.classList.remove('modal--open')

            modal.isOpen = false
            modal.current = null
        }
    }

    onMouseEnter = (event) => { /** Code your own */ }

    onMouseLeave = () => { /** Code your own */ }

    destroy() {
        this.modals = document.querySelectorAll('[data-modal]')
        each(this.modals, (modal) => {

            modal.classList.remove('active')
            document.body.classList.remove('scroll--off')

            gsap.to(modal, {
                delay: .5,
                onComplete: modal.remove()
            })
        })
    }
}

export const ModalManager = new Modal()